import { get } from 'lodash-es'

import { SiteContext } from '.'

import type { TCacheDataKey } from '@/helpers/cache-data/_helpers'

export const useConfig = () => {
  const context = useContext(SiteContext)

  if (!context.config) {
    throw new Error('config is none')
  }
  return context.config
}

export function useCacheData<T = unknown>(key: TCacheDataKey) {
  const context = useContext(SiteContext)
  return (get(context.cacheData, [key]) as T) || null
}

export const useBrowserInfo = () => {
  const context = useContext(SiteContext)

  if (!context.browserInfo) {
    throw new Error('browserInfo is none')
  }
  return context.browserInfo
}
